import { useRef, lazy, Suspense, startTransition, useEffect, useState, type JSX } from 'react';
import classNames from 'classnames';
import styles from './Icon.module.scss';

export type IconProps = {
  name: string;
  className?: string;
  transparent?: boolean;
  onClick?: () => void;
  role?: React.AriaRole;
  ref?: React.RefObject<HTMLElement | null>;
};

export default function Icon({
  ref,
  name,
  className,
  transparent = false,
  onClick,
  role,
  ...props
}: IconProps): JSX.Element {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as React.RefObject<HTMLDivElement | null>;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [IconComponent, setIconComponent] = useState<React.LazyExoticComponent<any> | null>(null);

  useEffect(() => {
    startTransition(() => {
      const Icon = lazy(() => import(`../../../assets/svg/${name}.svg`));
      setIconComponent(Icon);
    });
  }, [name]);

  return (
    <div
      ref={elementRef}
      className={classNames(styles.icon, className, {
        [styles.transparent]: transparent,
      })}
      onClick={onClick}
      onKeyDown={onClick}
      tabIndex={0}
      role={role}
    >
      {IconComponent && (
        <Suspense>
          <IconComponent {...props} />
        </Suspense>
      )}
    </div>
  );
}
